import { gql } from '@apollo/client';

export const GET_CONSULTATION_FORMS = gql`
  query GetConsultationForms($input: MyFormsInput!) {
    forms: userMyForms(input: $input) {
      id
      workspaceForm {
        id
        name
        version
        published
        template {
          id
          jsonData
        }
      }
    }
  }
`;
